<template>
  <section class="closefriend-hero">
    <loading-modal :is-loading="isLoading"></loading-modal>
    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>
    <influencer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></influencer-menu>
    <header-menu @slideMenu="slideBar()" :is-loading="isLoading"> </header-menu>

    <div class="container-fluid mt-3 pb-5">
      <div class="row justify-content-center">
        <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <!-- Header -->
          <div class="mb-4 mt-2 px-1">
            <h5 class="text-white font-weight-700 mb-0 font-size-20">Billing & Payouts</h5>
            <span class="text-muted font-size-12">Manage payout methods & bank settings</span>
          </div>
            <div class="row">
              <div class="col-12">

                <div class="custom-card-transparent">
                  <div class="stella-card-body p-4">
                    <template v-if="isAgency(AGENCY_SOMNIUM)">
                      <br>
                      <b>Please contact info@ramiroproductions.com for payment information</b>
                    </template>
                    <div v-else>
                      <global-message></global-message>
                      <div class="d-flex justify-content-center mb-4">
                        <label
                          class="btn btn-outline payment-button active px-5"
                          style="background: rgba(255, 255, 255, 0.05) !important; border: 1px solid #55EFC4; color: #55EFC4; border-radius: 12px; cursor: default;">
                          <div class="d-flex align-items-center justify-content-center py-2">
                            <i class="fa fa-university mr-2"></i>
                            <span class="font-weight-600 m-0">Bank Account</span>
                          </div>
                        </label>
                      </div>
                      <template v-if="isPayPal">
                        <div class="form-group mt-4 mx-md-2 mx-0" data-paypal>
                          <span class="danger ml-2" v-if="isRequired('paypalEmail')">This is required field</span>
                          <span class="danger ml-2" v-if="isValidEmail('paypalEmail')">Not a valid email address</span>
                          <input type="email" class="form-control stella-group" name="email"
                                 placeholder="Paypal Email Address*"
                                 v-model.lazy="paypalEmail">
                        </div>
                      </template>
                      <template v-else>
                        <div class="row bank-payment-form px-1">
                          <div class="col-12 mb-3" data-bank>
                            <div class="form-group mb-0">
                              <input type="text" name="bank_name" class="form-control stella-group"
                                     placeholder="Bank Name" v-model.lazy="bankName">
                              <span class="error invalid-feedback d-block mt-1" v-if="isRequired('bankName')">This is required field</span>
                            </div>
                          </div>
                          
                          <div class="col-12 col-md-6 mb-3" data-bank>
                            <div class="form-group mb-0">
                              <input type="number" min="0" class="form-control stella-group" placeholder="Account Number"
                                     v-model.lazy="accountNumber"
                                     onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                              <span class="error invalid-feedback d-block mt-1" v-if="isRequired('accountNumber')">This is required field</span>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 mb-3" data-bank>
                            <div class="form-group mb-0">
                              <input type="number" min="0" class="form-control stella-group" placeholder="Re-enter Account Number"
                              v-model.lazy="reEnteredAccountNumber"
                              onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                              <span class="error invalid-feedback d-block mt-1" v-if="isRequired('reEnteredAccountNumber')">This is required field</span>
                              <span class="error invalid-feedback d-block mt-1" v-else-if="isSameAs('reEnteredAccountNumber')">Account numbers do not match</span>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 mb-3" data-bank>
                            <div class="form-group mb-0">
                              <input type="number" min="0" class="form-control stella-group" placeholder="Routing Number"
                                     v-model.lazy="routingNumber"
                                     onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                              <span class="error invalid-feedback d-block mt-1" v-if="isRequired('routingNumber')">This is required field</span>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 mb-3" data-bank>
                            <div class="form-group mb-0">
                              <input type="number" min="0" class="form-control stella-group" placeholder="Re-enter Routing Number"
                              v-model.lazy="reEnteredRoutingNumber"
                              onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                              <span class="error invalid-feedback d-block mt-1" v-if="isRequired('reEnteredRoutingNumber')">This is required field</span>
                              <span class="error invalid-feedback d-block mt-1" v-else-if="isSameAs('reEnteredRoutingNumber')">Routing numbers do not match</span>
                            </div>
                          </div>
                        </div>
                      </template>
                      <div class="form-group pt-4 mb-0 text-center">
                        <button type="submit" class="btn gradient-a text-white border-radius-10 font-weight-bold font-size-16 py-2 px-5" @click="save()">
                          Save
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

import {httpMixin} from "@/mixin/http-mixin";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import InfluencerMenu from "@/components/module/influencer/shared/InfluencerMenu";
import InfluencerHeader from "@/components/module/influencer/shared/InfluencerHeader";
import {isStringWithOnlySpaces} from '@/common/Utils';
import {email, required, sameAs} from "vuelidate/lib/validators";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import {constructCustomerURL} from "@/common/baseURL-service";
import {AGENCY_SOMNIUM} from "@/properties/agency";
import {newSubscriptionMixin} from "@/mixin/new-subscription-mixin";
import PwaActionBar from "@/components/module/influencer/shared/PwaActionBar";
import LoadingModal from "@/components/module/shared/LoadingModal";

export default {
  name: 'BillingMobile',
  mixins: [httpMixin, newSubscriptionMixin],
  components: {HeaderMenu, InfluencerMenu, InfluencerHeader, GlobalMessage, PwaActionBar, LoadingModal},
  data() {
    return {
      isPayPal: true,
      isBank: false,
      user: {},
      showSlideBar: false,
      AGENCY_SOMNIUM,

      id: null,
      paypalEmail: null,
      bankName: null,
      accountNumber: '',
      routingNumber: '',
      reEnteredRoutingNumber: null,
      reEnteredAccountNumber: null,

      isSubmitted: false,
    }
  },
  validations() {
    if (this.isPayPal) {
      return {
        paypalEmail: {required, email}
      }
    } else {
      return {
        bankName: {required},
        accountNumber: {required},
        routingNumber: {required},
        reEnteredRoutingNumber: {required, sameAs: sameAs('routingNumber')},
        reEnteredAccountNumber: {required, sameAs: sameAs('accountNumber')},
      }
    }
  },
  created() {
    this.user = this.getUser();
    this.getData(`identity/api/v1/influencers/${this.user.id}/billing`, (data) => {
      if (data) {
        console.log(data);
        this.setBilling(data);
      }
    });
    this.checkNewSubscription(this.user.id);
  },
  computed: {
    copyLabel() {
      return this.copied ? 'Copied' : 'Copy';
    }
  },
  methods: {
    ...mapGetters(['getUser']),
    ...mapActions(['setMessage']),
    isAgency(name) {
       return this.user.agency && this.user.agency.name.toLowerCase() === name;
    },
    constructCustomerURL,
    setBilling(data) {
      if (!data.paypalEmail) {
        this.id = data.id;
        this.isPayPal = false;
        this.isBank = true;
        this.bankName = data.bankName;
        this.accountNumber = data.accountNumber? data.accountNumber.toString(): '';
        this.routingNumber = data.routingNumber? data.routingNumber.toString(): '';
      } else {
        this.id = data.id;
        this.paypalEmail = data.paypalEmail;
      }
    },
    checkPasswordReq() {
      this.isPasswordRequired = isStringWithOnlySpaces(this.user.password);
    },
    isRequired(attrib) {
      return this.isSubmitted && !this.$v[attrib].required;
    },
    isSameAs(attrib) {
      return this.isSubmitted && !this.$v[attrib].sameAs;
    },
    isValidEmail() {
      return this.isSubmitted && !this.$v.paypalEmail.email;
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },
    save() {
      this.isSubmitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
       /* console.log(this.$v);*/
        return;
      }

      let userBilling;
      if (this.isPayPal) {
        userBilling = {
          id: this.id,
          bankName: null,
          accountNumber: null,
          routingNumber: null,
          paypalEmail: this.paypalEmail
        }
      } else {
        userBilling = {
          id: this.id,
          bankName: this.bankName,
          accountNumber: this.accountNumber,
          routingNumber: this.routingNumber,
          paypalEmail: null
        }
      }

      this.postData(`identity/api/v1/influencers/${this.user.id}/billing`, userBilling, (data) => {
        this.userBilling = data;
        this.setBilling(data);
        this.setMessage('Saved successfully');
      });
    }

  }
}
</script>

<style scoped>
.closefriend-hero {
  background-color: #111111 !important;
  background-image: none !important;
  min-height: 100vh;
}

.container-fluid, .row, .col-12 {
  background-color: transparent !important;
  background-image: none !important;
}




.stella-group {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  border-radius: 8px !important;
  padding: 12px 16px;
}
.stella-group:focus {
  border-color: rgba(255, 89, 212, 0.6) !important;
  box-shadow: 0 0 0 2px rgba(255, 89, 212, 0.2) !important;
  background: rgba(255, 255, 255, 0.08) !important;
}
.stella-group::placeholder {
  color: rgba(255, 255, 255, 0.3) !important;
}
</style>
